import React from "react";
import * as util from '../Helpers/Util';

const KodSecimKural = {
    1 : "Raportor seçimi zorunlu değil",
    2 : "En az bir raportör seçimi yapmalısınız!",
    3 : "Raportör seçimi yaptığınız için, lütfen mimari raportör seçimi de yapmalısınız!",
    4 : "Bütün süreçler için rapotör seçimi yapmalısınız!",
    5 : "Ruhsat ve Mekanik süreci raportör seçimi yapmalısınız!"
}

const KodAltSurecTipi = {
    YeniYapiResmiRuhsatSureci   : 10000,
    TadilatResmiRuhsatSureci    : 20000,
    YenidenResmiRuhsatSureci    : 40000,
    KatIlavesiResmiRuhsatSureci : 60000,


    YeniYapiMekanikProjeOnayi   : 11000,
    TadilatMekanikProjeOnayi    : 21000,
    YenidenMekanikProjeOnayi    : 41000,
    KatIlavesiMekanikProjeOnayi : 61000,

    YeniYapiMimariProjeOnayi   : 12000,
    TadilatMimariProjeOnayi    : 22000,
    YenidenMimariProjeOnayi    : 42000,
    KatIlavesiMimariProjeOnayi : 62000,
}

export const raportorSecimKuralValidation = (secimKuralTuruId,data) => {
    var result = {
        succes : true ,
        message : ""
    }
    switch(secimKuralTuruId) {
        case 2 : {
          if(Object.values(data).filter(d => !util.isNullOrEmptyOrUndefined(d)).length == 0){
            result.succes = false;
            result.message = KodSecimKural[secimKuralTuruId];
          }
          break;
        }
        case 3 : {
            if(Object.values(data).filter(d => !util.isNullOrEmptyOrUndefined(d)).length > 0){
                if(    util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.YeniYapiMimariProjeOnayi])
                    && util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.TadilatMimariProjeOnayi])
                    && util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.YenidenMimariProjeOnayi])
                    && util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.KatIlavesiMimariProjeOnayi])){
                    result.succes = false;
                    result.message = KodSecimKural[secimKuralTuruId];
                }
              }
              break;
        }
        case 4 : {
            Object.keys(data).forEach(function(key) {  
                if(util.isNullOrEmptyOrUndefined(data[key])){
                    result.succes = false;
                    result.message = KodSecimKural[secimKuralTuruId];
                }
            });
            break;
        }
        case 5 : {
            
            if((util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.YeniYapiResmiRuhsatSureci]) || util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.YeniYapiMekanikProjeOnayi]))
                && (util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.TadilatResmiRuhsatSureci]) || util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.TadilatMekanikProjeOnayi]))
                && (util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.YenidenResmiRuhsatSureci]) || util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.YenidenMekanikProjeOnayi]))
                && (util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.KatIlavesiResmiRuhsatSureci]) || util.isNullOrEmptyOrUndefined(data[KodAltSurecTipi.KatIlavesiMekanikProjeOnayi]))){
                result.succes = false;
                result.message = KodSecimKural[secimKuralTuruId];
            }

            break;
        }
        default : {
            result.message = "Rapörtor Seçimi İçin Kural Tanımlanmadığı İçin İşleme Devam Edilemez.";
            break;
        }
    }

    return result;
}